// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xPartNumberStyle } from "@eisinc/App/SharedStyles/ProductPartNumberStyle";
import { productPartNumbersStyles } from "@eisinc/Overrides/Components/ProductPartNumbers";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { css } from "styled-components";

productPartNumbersStyles.container = {
    gap: 2,
    // using as="ul" for improved semantic structure
    offsetProps: {
        as: "ul",
    },
};

productPartNumbersStyles.labelText = {
    ...xPartNumberStyle.value,
    ...fontConfig.singleLinexSmall,
    weight: fontConfig.weight.medium,
    css: css`
        margin-right: 4px;
        margin-bottom: 0;
        flex-shrink: 0;
        display: inline-block;
        &:after {
            content: ":";
        }
    `,
};

productPartNumbersStyles.valueText = {
    ...xPartNumberStyle.value,
    ...fontConfig.singleLinexSmall,
};
